__webpack_require__.p = "https://ordering-latte-test-cdn.foodtecsolutions.com/main_186578/";